import Model from './Model';

export default class AffiliatePaymentBonus extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'affiliate-payment-bonuses';
  }
}
